// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__brHkw","question":"Question_question__qKXF5","description":"Question_description__3STj3"};